import React, { useRef, Fragment } from 'react';
import { motion, useInView } from 'framer-motion';
const steps = ['Put Away Distractions', 'Sit Comfortably', 'Close Your Eyes', 'Breathe', 'Smile'];
export function Experience() {
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section id="philosophy" className="relative w-full overflow-hidden" data-id="element-105">
      {/* Full-bleed background image */}
      <div className="absolute inset-0" data-id="element-106">
        <img src="https://cdn.magicpatterns.com/uploads/37zuM6WeZ6jGo29LCDuCPg/ZenB-7-1024x768.jpg" alt="" className="w-full h-full object-cover" data-id="element-107" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(to bottom, rgba(61,50,41,0.75) 0%, rgba(61,50,41,0.7) 50%, rgba(61,50,41,0.78) 100%)'
      }} data-id="element-108" />
      </div>

      {/* Content */}
      <div className="relative z-10 py-24 md:py-32 px-6 lg:px-8" ref={ref} data-id="element-109">
        <div className="max-w-4xl mx-auto text-center" data-id="element-110">
          {/* Header */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.8
        }} data-id="element-111">
            <p className="text-sm font-body font-medium tracking-[0.3em] uppercase text-cream/50 mb-5" data-id="element-112">
              Our Philosophy
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold text-cream leading-[1.15] italic mb-10" data-id="element-113">
              The Art of Sitting
              <br data-id="element-114" />
              and Doing Nothing
            </h2>
          </motion.div>

          {/* Steps — horizontal flow on desktop, clean stack on mobile */}
          <motion.div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-4 md:gap-x-4" initial={{
          opacity: 0,
          y: 20
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.8,
          delay: 0.3
        }} data-id="element-115">
            {steps.map((step, i) => <Fragment key={step} data-id="element-116">
                <motion.span initial={{
              opacity: 0,
              y: 10
            }} animate={inView ? {
              opacity: 1,
              y: 0
            } : {}} transition={{
              duration: 0.5,
              delay: 0.4 + i * 0.15
            }} className="font-heading text-xl sm:text-2xl md:text-3xl font-medium text-cream" data-id="element-117">
                  {step}
                </motion.span>
                {i < steps.length - 1 && <motion.span initial={{
              opacity: 0,
              scale: 0
            }} animate={inView ? {
              opacity: 1,
              scale: 1
            } : {}} transition={{
              duration: 0.3,
              delay: 0.55 + i * 0.15
            }} className="text-terracotta text-lg md:text-xl" data-id="element-118">
                    →
                  </motion.span>}
              </Fragment>)}
          </motion.div>

          {/* Closing line */}
          <motion.p className="font-body text-cream/45 text-base md:text-lg mt-10" initial={{
          opacity: 0
        }} animate={inView ? {
          opacity: 1
        } : {}} transition={{
          duration: 0.8,
          delay: 1.4
        }} data-id="element-119">
            You are here. That is enough.
          </motion.p>
        </div>
      </div>
    </section>;
}